import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableSixDots = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 7,
	height: 12,
	viewBox: "0 0 7 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.55859 7C2.11088 7 2.55859 6.55228 2.55859 6C2.55859 5.44772 2.11088 5 1.55859 5C1.00631 5 0.558594 5.44772 0.558594 6C0.558594 6.55228 1.00631 7 1.55859 7Z",
			fill: "#AAAAAA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.55859 2C2.11088 2 2.55859 1.55228 2.55859 1C2.55859 0.447715 2.11088 0 1.55859 0C1.00631 0 0.558594 0.447715 0.558594 1C0.558594 1.55228 1.00631 2 1.55859 2Z",
			fill: "#AAAAAA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.55859 12C2.11088 12 2.55859 11.5523 2.55859 11C2.55859 10.4477 2.11088 10 1.55859 10C1.00631 10 0.558594 10.4477 0.558594 11C0.558594 11.5523 1.00631 12 1.55859 12Z",
			fill: "#AAAAAA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.05859 7C5.61088 7 6.05859 6.55228 6.05859 6C6.05859 5.44772 5.61088 5 5.05859 5C4.50631 5 4.05859 5.44772 4.05859 6C4.05859 6.55228 4.50631 7 5.05859 7Z",
			fill: "#AAAAAA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.05859 2C5.61088 2 6.05859 1.55228 6.05859 1C6.05859 0.447715 5.61088 0 5.05859 0C4.50631 0 4.05859 0.447715 4.05859 1C4.05859 1.55228 4.50631 2 5.05859 2Z",
			fill: "#AAAAAA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.05859 12C5.61088 12 6.05859 11.5523 6.05859 11C6.05859 10.4477 5.61088 10 5.05859 10C4.50631 10 4.05859 10.4477 4.05859 11C4.05859 11.5523 4.50631 12 5.05859 12Z",
			fill: "#AAAAAA"
		})
	]
});
const ForwardRef = forwardRef(SvgTableSixDots);
export { ForwardRef as ReactComponent };
